import OnboardingContainer from "@features/auth/components/OnboardingRouteContainer";
import { OnboardingContextProvider } from "@features/auth/contexts/OnboardingContext";
import DocumentTitle from "components/DocumentTitle";
import { Stack } from "expo-router";

const OnboardingRoute = () => {
	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Onboarding" />
			<OnboardingContextProvider>
				<OnboardingContainer />
			</OnboardingContextProvider>
		</>
	);
};

export default OnboardingRoute;
